module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intersecting-circles-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "spinnerBlock",
    style: (_vm.spinnerBlockStyle)
  }, _vm._l((_vm.circleStyles), function(cs, index) {
    return _c('span', {
      key: index,
      staticClass: "circle",
      style: (cs)
    })
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ce0e2b6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/epic-spinners/src/components/lib/IntersectingCirclesSpinner.vue
// module id = 382
// module chunks = 1